import { Link } from 'react-router-dom';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="bg-white border-b border-[#F5E6E0] sticky top-0 z-50">
        <div className="container mx-auto px-6 py-4">
          <span className="font-bold text-xl text-[#bc6355]">LÝFT SOY PROTEIN</span>
        </div>
      </header>

      {/* Breadcrumb Navigation */}
      <nav className="bg-[#FFF9F7] border-b border-[#F5E6E0]">
        <div className="container mx-auto px-6 py-3">
          <ul className="flex items-center gap-2 text-sm">
            <li>
              <a 
                href="https://soyproteinranking.com/" 
                className="flex items-center gap-2 text-[#D4A59A] hover:text-[#bc6355] transition-colors whitespace-nowrap"
              >
                <span className="w-4 h-4 flex items-center justify-center text-[#bc6355]">
                  <i className="ri-home-4-line"></i>
                </span>
                <span>トップ</span>
              </a>
            </li>
            <li className="text-[#E8D4CF]">/</li>
            <li className="text-[#6B5750] whitespace-nowrap">LÝFTで妥協のないボディメイクを</li>
          </ul>
        </div>
      </nav>

      {/* Main Content */}
      <main className="container mx-auto px-6 py-12 max-w-4xl">
        {/* Hero Section */}
        <div className="mb-12">
          <h1 className="text-3xl font-bold text-white mb-6 bg-gradient-to-r from-[#bc6355] to-[#D4A59A] px-6 py-4 rounded-lg leading-tight">
            LÝFT SOY PROTEINで理想の身体をデザインする
          </h1>
          <p className="text-[#6B5750] leading-relaxed mb-4">
            「プロテインは味が苦手」「トレーニングの効果を最大限引き出したい」「毎日飲むものだから質にこだわりたい」と追求していませんか？
          </p>
          <p className="text-[#6B5750] leading-relaxed">
            <span className="text-[#bc6355] font-semibold underline decoration-[#F5E6E0] decoration-4">
              LÝFT（リフト）SOY PROTEIN
            </span>
            は、
            <span className="border-b-2 border-[#bc6355] font-semibold">
              業界最高水準のタンパク質含有量
            </span>
            を誇り、エドワード加藤プロデュースによる「継続できる美味しさ」を徹底的に追求した進化系ソイプロテインです。
          </p>
        </div>

        {/* Features Section */}
        <section className="mb-12">
          <h2 className="text-2xl font-bold text-[#6B5750] mb-6 pb-3 border-b-4 border-[#bc6355]">
            LÝFTの特徴や概要
          </h2>
          <p className="text-[#6B5750] leading-relaxed mb-6">
            <span className="text-[#bc6355] font-semibold">LÝFT SOY PROTEIN</span>
            は、日本発のフィットネスブランドとして、機能性とファッション性を両立させたプレミアムプロテインです。
          </p>
          <p className="text-[#6B5750] leading-relaxed mb-8">
            最大の特徴は、ソイプロテイン特有の
            <span className="border-b-2 border-[#bc6355] font-semibold">
              粉っぽさを完全に払拭した、驚くほど滑らかな喉越し
            </span>
            です。高タンパクでありながら、贅沢なフレーバーを楽しみながらボディメイクをサポートします。
          </p>

          <h3 className="text-xl font-bold text-[#6B5750] mb-6">LÝFTがひと目でわかる!</h3>
          <div className="overflow-hidden rounded-lg border border-[#F5E6E0] shadow-sm mb-8 bg-white">
            <table className="w-full">
              <thead>
                <tr className="bg-[#FFF9F7]">
                  <th className="px-6 py-4 text-left text-sm font-semibold text-[#6B5750] border-b border-[#F5E6E0] w-1/3">
                    項目
                  </th>
                  <th className="px-6 py-4 text-left text-sm font-semibold text-[#6B5750] border-b border-[#F5E6E0]">
                    内容
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-[#F5E6E0]">
                <tr className="hover:bg-[#FFF9F7] transition-colors">
                  <td className="px-6 py-4 bg-[#bc6355] text-white font-semibold text-sm">タンパク質</td>
                  <td className="px-6 py-4 text-[#6B5750] text-sm">1食あたり約20g以上の高含有量</td>
                </tr>
                <tr className="hover:bg-[#FFF9F7] transition-colors">
                  <td className="px-6 py-4 bg-[#bc6355] text-white font-semibold text-sm">アミノ酸スコア</td>
                  <td className="px-6 py-4 text-[#6B5750] text-sm">最高値100（理想的なバランス）</td>
                </tr>
                <tr className="hover:bg-[#FFF9F7] transition-colors">
                  <td className="px-6 py-4 bg-[#bc6355] text-white font-semibold text-sm">フレーバー</td>
                  <td className="px-6 py-4 text-[#6B5750] text-sm">黒糖きな粉 / マンゴー / 抹茶などの本格派</td>
                </tr>
                <tr className="hover:bg-[#FFF9F7] transition-colors">
                  <td className="px-6 py-4 bg-[#bc6355] text-white font-semibold text-sm">品質管理</td>
                  <td className="px-6 py-4 text-[#6B5750] text-sm">国内GMP認定工場で製造の安心品質</td>
                </tr>
                <tr className="hover:bg-[#FFF9F7] transition-colors">
                  <td className="px-6 py-4 bg-[#bc6355] text-white font-semibold text-sm">利便性</td>
                  <td className="px-6 py-4 text-[#6B5750] text-sm">ダマになりにくく、水でさらっと溶ける</td>
                </tr>
              </tbody>
            </table>
          </div>
        </section>

        {/* Usage Points Section */}
        <section className="mb-12">
          <h2 className="text-2xl font-bold text-[#6B5750] mb-6 pb-3 border-b-4 border-[#bc6355]">
            LÝFTの活用ポイント
          </h2>
          <div className="mb-8">
            <h4 className="text-lg font-bold text-[#6B5750] mb-4 border-b-2 border-[#F5E6E0] pb-2 inline-block">
              1.「本格志向」を支える高い栄養価
            </h4>
            <p className="text-[#6B5750] leading-relaxed">
              トレーニングをしている方はもちろん、健康維持を目的とする方にも最適な
              <strong className="text-[#bc6355]">アミノ酸バランス</strong>
              。植物性タンパク質がゆっくりと吸収され、理想の体づくりを長時間サポートします。
            </p>
          </div>
          <div className="mb-8">
            <h4 className="text-lg font-bold text-[#6B5750] mb-4 border-b-2 border-[#F5E6E0] pb-2 inline-block">
              2.ジュース感覚で飲める「圧倒的な旨さ」
            </h4>
            <p className="text-[#6B5750] leading-relaxed">
              <strong className="text-[#bc6355]">「これがプロテイン？」</strong>
              と驚くほどのクオリティ。甘すぎず、かつ満足感のあるフレーバーが、ハードな日々の楽しみになります。
            </p>
          </div>
          <div className="mb-8">
            <h4 className="text-lg font-bold text-[#6B5750] mb-4 border-b-2 border-[#F5E6E0] pb-2 inline-block">
              3.毎日の習慣を彩る「洗練されたパッケージ」
            </h4>
            <p className="text-[#6B5750] leading-relaxed">
              キッチンのインテリアを邪魔しない
              <strong className="text-[#bc6355]">ミニマルで洗練されたデザイン</strong>
              。持つだけでモチベーションが上がるパッケージが、継続という一番の課題を解決します。
            </p>
          </div>
        </section>

        {/* Recommended For Section */}
        <section className="mb-12">
          <h2 className="text-2xl font-bold text-[#6B5750] mb-6 pb-3 border-b-4 border-[#bc6355]">
            LÝFTはこんな人におすすめ
          </h2>
          <div className="bg-gradient-to-br from-[#FFF9F7] to-[#FFF5F2] rounded-xl p-8 border border-[#F5E6E0] shadow-sm">
            <div className="flex items-center justify-center mb-6">
              <span className="bg-[#bc6355] text-white px-4 py-2 rounded-full text-sm font-bold">
                CHECK!
              </span>
            </div>
            <ol className="space-y-4">
              <li className="flex items-start gap-3">
                <div className="flex-shrink-0 w-6 h-6 rounded-full bg-[#bc6355] text-white flex items-center justify-center text-sm font-semibold mt-0.5">
                  1
                </div>
                <p className="text-[#6B5750]">味に一切の妥協をしたくない、最高に美味しいプロテインを探している</p>
              </li>
              <li className="flex items-start gap-3">
                <div className="flex-shrink-0 w-6 h-6 rounded-full bg-[#bc6355] text-white flex items-center justify-center text-sm font-semibold mt-0.5">
                  2
                </div>
                <p className="text-[#6B5750]">ホエイよりもソイ派だが、しっかりとしたタンパク質量を確保したい</p>
              </li>
              <li className="flex items-start gap-3">
                <div className="flex-shrink-0 w-6 h-6 rounded-full bg-[#bc6355] text-white flex items-center justify-center text-sm font-semibold mt-0.5">
                  3
                </div>
                <p className="text-[#6B5750]">モチベーションを高めるために、洗練されたブランドのものを使いたい</p>
              </li>
              <li className="flex items-start gap-3">
                <div className="flex-shrink-0 w-6 h-6 rounded-full bg-[#bc6355] text-white flex items-center justify-center text-sm font-semibold mt-0.5">
                  4
                </div>
                <p className="text-[#6B5750]">お腹に優しく、腹持ちの良いプロテインを習慣にしたい</p>
              </li>
            </ol>
          </div>
        </section>

        {/* Summary Section */}
        <section className="mb-12">
          <h2 className="text-2xl font-bold text-[#6B5750] mb-6 pb-3 border-b-4 border-[#bc6355]">
            まとめ
          </h2>
          <div className="bg-gradient-to-br from-[#FFF9F7] to-[#FFF5F2] rounded-xl p-8 border border-[#F5E6E0] shadow-sm">
            <div className="flex items-center justify-center mb-6">
              <span className="bg-[#bc6355] text-white px-4 py-2 rounded-full text-sm font-bold">
                POINT
              </span>
            </div>
            <div className="space-y-4 text-[#6B5750]">
              <p className="flex items-start gap-2">
                <span className="text-[#bc6355] font-bold">•</span>
                <span>
                  <strong className="text-[#bc6355]">圧倒的な美味しさ:</strong> プロテインの概念を覆すフレーバーの再現度
                </span>
              </p>
              <p className="flex items-start gap-2">
                <span className="text-[#bc6355] font-bold">•</span>
                <span>
                  <strong className="text-[#bc6355]">高純度タンパク質:</strong> 植物性でありながら1食で理想的な栄養補給
                </span>
              </p>
              <p className="flex items-start gap-2">
                <span className="text-[#bc6355] font-bold">•</span>
                <span>
                  <strong className="text-[#bc6355]">洗練された体験:</strong> ボディメイクをライフスタイルとして格上げする品質
                </span>
              </p>
            </div>
          </div>
          <p className="text-[#6B5750] leading-relaxed mt-8 text-center font-bold">
            「本物」を追求するあなたに、LÝFTという選択を。
          </p>

          {/* Product Image */}
          <a
            href="https://soyproteinranking.com/web/LYFT.php?p=sh"
            target="_blank"
            rel="noopener noreferrer"
            className="block mt-12 cursor-pointer hover:opacity-90 transition-opacity"
          >
            <div className="w-full h-auto">
              <img
                alt="LÝFT SOY PROTEIN - プレミアムソイプロテイン"
                className="w-full h-auto rounded-lg shadow-md object-cover"
                src="https://static.readdy.ai/image/c28b677376caa266f389c59db123aec1/77fd1a8f862d5ff70fdd6e37b07c3044.png"
              />
            </div>
          </a>

          {/* CTA Section */}
          <div className="mt-8 bg-[#bc6355] rounded-lg py-8 px-6 text-center">
            <p className="text-white text-sm font-medium mb-4 tracking-wide">
              アスリートも認めるハイクオリティ
            </p>
            <a
              href="https://soyproteinranking.com/web/LYFT.php?p=sh"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block bg-[#FFF9F7] rounded-lg px-8 py-4 mb-6 cursor-pointer hover:shadow-lg transition-shadow"
            >
              <p className="text-[#8B7B74] text-xs mb-1">エドワード加藤プロデュース</p>
              <p className="text-[#bc6355] text-2xl font-bold tracking-wide">LÝFT</p>
              <p className="text-[#bc6355] text-xs tracking-widest">SOY PROTEIN</p>
            </a>
            <div>
              <a
                href="https://soyproteinranking.com/web/LYFT.php?p=sh"
                target="_blank"
                rel="noopener noreferrer"
                className="relative inline-block bg-white text-[#bc6355] font-bold py-4 px-12 rounded-full cursor-pointer hover:shadow-lg transition-all overflow-hidden group whitespace-nowrap"
              >
                <span className="relative z-10">LÝFT SOY PROTEINの詳細を見る</span>
              </a>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
}